export const data = [
	{
		id: 1,
		icon: (
			<svg
				style={{ transform: 'scale(1.5)' }}
				width="53"
				height="40"
				viewBox="0 0 53 40"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M46.7844 6.15261C46.8853 6.24178 46.9556 6.36235 46.9849 6.49632C47.0141 6.63028 47.0007 6.77045 46.9467 6.89588C45.066 11.2613 41.1166 17.2941 38.2256 20.4377C37.4152 21.3171 36.4158 21.986 35.3087 22.3901C35.2866 22.679 35.2349 23.0748 35.112 23.4948C34.865 24.3335 34.2922 25.3772 33.0126 25.7093C31.7733 26.0149 30.4891 26.0719 29.2291 25.8773C28.9948 25.839 28.7638 25.7816 28.5383 25.7055C28.3297 25.6398 28.1352 25.533 27.9655 25.3912C27.8536 25.2926 27.7674 25.1666 27.7147 25.0246C27.6495 24.8424 27.6513 24.6417 27.7197 24.4608C27.8364 24.149 28.1081 23.9772 28.2863 23.8855C28.7706 23.6348 29.0546 23.309 29.352 22.8342C29.4688 22.651 29.5782 22.4562 29.7048 22.2335L29.8486 21.9815C30.0342 21.657 30.2493 21.2942 30.5198 20.9022C31.1688 19.9617 31.996 19.725 32.6659 19.7619C32.8208 19.7708 32.9646 19.7937 33.0937 19.823C33.1699 19.6041 33.2682 19.3393 33.3862 19.0492C33.7071 18.2613 34.195 17.2432 34.8453 16.4159C37.52 13.0177 42.4417 8.51734 46.0518 6.1017C46.163 6.02742 46.2943 5.99226 46.4263 6.00143C46.5583 6.0106 46.6839 6.06362 46.7844 6.15261Z"
					fill="#AED6DC"
				/>
				<path
					d="M8 10.48C8 10.48 8 6 12.1485 6H37.0396C37.0396 6 41.1882 6 41.1882 10.48V23.92C41.1882 23.92 41.1882 28.4 37.0396 28.4H28.7426C28.7426 29.8941 28.9148 31.0141 29.2612 31.76H30.8169C31.0919 31.76 31.3557 31.878 31.5502 32.088C31.7447 32.2981 31.854 32.583 31.854 32.88C31.854 33.177 31.7447 33.4619 31.5502 33.672C31.3557 33.882 31.0919 34 30.8169 34H18.3713C18.0962 34 17.8324 33.882 17.6379 33.672C17.4434 33.4619 17.3342 33.177 17.3342 32.88C17.3342 32.583 17.4434 32.2981 17.6379 32.088C17.8324 31.878 18.0962 31.76 18.3713 31.76H19.927C20.2734 31.0141 20.4456 29.8941 20.4456 28.4H12.1485C12.1485 28.4 8 28.4 8 23.92V10.48ZM10.8998 8.5648C10.672 8.73611 10.4902 8.96951 10.373 9.24128C10.1961 9.63579 10.0946 10.0647 10.0743 10.5024V23.92C10.0743 24.648 10.2361 25.0445 10.375 25.2685C10.5202 25.5037 10.7277 25.6896 11.0015 25.8374C11.351 26.0203 11.7299 26.129 12.1174 26.1578L12.1693 26.16H37.0396C37.7138 26.16 38.0809 25.9853 38.2883 25.8352C38.5162 25.6639 38.698 25.4305 38.8152 25.1587C38.9845 24.7812 39.0852 24.3721 39.1118 23.9536L39.1139 23.8976V10.48C39.1139 9.752 38.9521 9.35552 38.8131 9.13152C38.6546 8.8854 38.4384 8.68907 38.1867 8.56256C37.8214 8.37162 37.4242 8.26193 37.0189 8.24H12.1485C11.4744 8.24 11.1072 8.41472 10.8998 8.5648Z"
					fill="#AED6DC"
				/>
			</svg>
		),
		name: 'Web Design',
		explain:
			'I craft visually appealing and user-friendly websites, create unique and captivating designs tailored to your brand, and transforming ideas into stunning digital experiences.',
	},
	{
		id: 2,
		icon: (
			<svg
				style={{
					transform: 'scale(1.8)',
					marginTop: '0px',
					marginBottom: '9px',
				}}
				width="35"
				height="31"
				viewBox="0 0 35 31"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M22.9206 3.19106C22.9629 3.06944 22.9776 2.94164 22.9641 2.81497C22.9506 2.68829 22.909 2.56522 22.8418 2.45277C22.7745 2.34032 22.6829 2.24071 22.5722 2.15961C22.4615 2.07851 22.3339 2.01752 22.1966 1.98012C22.0593 1.94272 21.915 1.92964 21.7719 1.94163C21.6289 1.95361 21.49 1.99043 21.363 2.04999C21.2361 2.10954 21.1236 2.19065 21.032 2.2887C20.9405 2.38675 20.8716 2.49981 20.8294 2.62143L12.0794 27.8089C11.9941 28.0546 12.0225 28.3201 12.1583 28.5472C12.294 28.7743 12.5261 28.9443 12.8034 29.0199C13.0808 29.0954 13.3806 29.0703 13.637 28.95C13.8934 28.8297 14.0853 28.6242 14.1706 28.3786L22.9206 3.19106ZM10.6181 8.03287C10.72 8.12286 10.8008 8.22976 10.8559 8.34746C10.9111 8.46515 10.9395 8.59132 10.9395 8.71875C10.9395 8.84617 10.9111 8.97234 10.8559 9.09004C10.8008 9.20773 10.72 9.31463 10.6181 9.40462L3.73406 15.5L10.6181 21.5954C10.8235 21.7773 10.9389 22.024 10.9389 22.2812C10.9389 22.5385 10.8235 22.7852 10.6181 22.9671C10.4128 23.149 10.1342 23.2512 9.84375 23.2512C9.5533 23.2512 9.27475 23.149 9.06938 22.9671L1.41313 16.1859C1.31127 16.0959 1.23046 15.989 1.17532 15.8713C1.12018 15.7536 1.0918 15.6274 1.0918 15.5C1.0918 15.3726 1.12018 15.2464 1.17532 15.1287C1.23046 15.011 1.31127 14.9041 1.41313 14.8141L9.06938 8.03287C9.17098 7.94266 9.29167 7.87108 9.42455 7.82224C9.55743 7.7734 9.69989 7.74827 9.84375 7.74827C9.98762 7.74827 10.1301 7.7734 10.2629 7.82224C10.3958 7.87108 10.5165 7.94266 10.6181 8.03287ZM24.3819 8.03287C24.28 8.12286 24.1992 8.22976 24.1441 8.34746C24.0889 8.46515 24.0605 8.59132 24.0605 8.71875C24.0605 8.84617 24.0889 8.97234 24.1441 9.09004C24.1992 9.20773 24.28 9.31463 24.3819 9.40462L31.2659 15.5L24.3819 21.5954C24.2802 21.6854 24.1995 21.7924 24.1445 21.9101C24.0894 22.0277 24.0611 22.1539 24.0611 22.2812C24.0611 22.4086 24.0894 22.5348 24.1445 22.6524C24.1995 22.7701 24.2802 22.8771 24.3819 22.9671C24.4836 23.0572 24.6043 23.1286 24.7372 23.1774C24.87 23.2261 25.0124 23.2512 25.1563 23.2512C25.3001 23.2512 25.4425 23.2261 25.5753 23.1774C25.7082 23.1286 25.8289 23.0572 25.9306 22.9671L33.5869 16.1859C33.6887 16.0959 33.7695 15.989 33.8247 15.8713C33.8798 15.7536 33.9082 15.6274 33.9082 15.5C33.9082 15.3726 33.8798 15.2464 33.8247 15.1287C33.7695 15.011 33.6887 14.9041 33.5869 14.8141L25.9306 8.03287C25.829 7.94266 25.7083 7.87108 25.5754 7.82224C25.4426 7.7734 25.3001 7.74827 25.1563 7.74827C25.0124 7.74827 24.8699 7.7734 24.7371 7.82224C24.6042 7.87108 24.4835 7.94266 24.3819 8.03287Z"
					fill="#AED6DC"
				/>
			</svg>
		),
		name: 'Frontend Development',
		explain:
			'I build interactive and responsive web interfaces, implement cutting-edge technologies to enhance user experience, and write clean and efficient code for seamless functionality.',
	},
	{
		id: 3,
		icon: (
			<svg
				style={{ transform: 'scale(1.8)', marginTop: '0px', marginBottom: '9px' }}
				width="35"
				height="31"
				viewBox="0 0 35 31"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M30 6H10C8.34315 6 7 7.34315 7 9V27C7 28.6569 8.34315 30 10 30H30C31.6569 30 33 28.6569 33 27V9C33 7.34315 31.6569 6 30 6Z"
					fill="grey"
				/>
				<rect x="12" y="12" width="16" height="2" fill="white" />
				<rect x="12" y="16" width="12" height="2" fill="white" />
				<rect x="12" y="20" width="8" height="2" fill="white" />
			</svg>
		),
		name: 'Backend Development',
		explain:
			'I develop robust server-side applications using Node.js and Express.js, create scalable APIs, and ensure efficient communication between the frontend and backend systems.',
	},
	{
		id: 4,
		icon: (
			<svg
				style={{ transform: 'scale(1.5)' }}
				width="40"
				height="40"
				viewBox="0 0 40 40"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<circle cx="20" cy="20" r="16" fill="grey" />
				<rect x="12" y="16" width="16" height="2" fill="white" />
				<rect x="12" y="20" width="16" height="2" fill="white" />
				<rect x="12" y="24" width="16" height="2" fill="white" />
			</svg>
		),
		name: 'Database Architecture',
		explain:
			'I design and optimize database structures using MongoDB, MySQL, and PostgreSQL, ensuring data integrity, security, and high-performance querying for complex applications.',
	},
];